<template>
  <div id="RequiredManageField" style="margin-left: 10px;">
    <el-collapse v-model="activeNames">
        <Card  v-for="(field,index) in projectsData" style="margin-bottom: 15px;">
          <el-collapse-item :name="field.projectName" :key="index"  v-if="collapseItemShow" class="my-collapse-item">
            <template slot="title"><div style="font-size: 18px;font-weight: bold;">{{field.projectName}}</div></template>

            <Form :ref="field.projectName" :model="model[field.projectName]">
              <template v-for="(rowItem, rowIndex) in getRowElements(field.projectName, field.fieldConfig, field.checkStatus)">
                <Row v-if="rowItem.isStartIndex">
                  <Col v-for="(item, colIndex) in getColElements(field.projectName, rowIndex)" :span="item.columnNumber?item.columnNumber:6" v-if="item.isShow">
                  <FormItem :prop="item.prop" :label="item.label" :label-width="item.labelWidth" :style="item.width" :required="item.isRequired&&item.isRequired==2">
                      <Input v-if="!item.element" :type="item.type" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"
                             :autocomplete="item.type === 'password' ? 'new-password' : ''"
                             :size="item.size" :disabled="true" :readonly="true"
                             :icon="item.icon" :prefix="item.prefix" :suffix="item.suffix"
                             :number="item.number" :rows="item.rows" :autosize="item.autosize" style="height:35px;width: 100%;" >
                        <span v-if="item.unit" slot="append"><span>{{item.unit}}</span></span>
                      </Input>

                      <Input v-if="item.element === 'number'" :type="item.type" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"
                             :size="item.size" :disabled="true" :readonly="true"
                             :icon="item.icon" :prefix="item.prefix" :suffix="item.suffix"
                             :number="item.number" :rows="item.rows" :autosize="item.autosize" style="height:35px;width: 100%;" >
                        <span v-if="item.unit" slot="append"><span>{{item.unit}}</span></span>
                      </Input>

                      <Input v-if="item.element === 'digit'" :type="item.type" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"
                             :size="item.size" :disabled="true" :readonly="true"
                             :icon="item.icon" :prefix="item.prefix" :suffix="item.suffix"
                             :number="item.number" :rows="item.rows" :autosize="item.autosize" style="height:35px;width: 100%;">
                        <span v-if="item.unit" slot="append"><span>{{item.unit}}</span></span>
                      </Input>

                      <Input v-if="item.element === 'textarea'" v-model="model[field.projectName][item.prop]" type="textarea" :placeholder="item.placeholder"
                             :size="item.size" :disabled="true" :readonly="true" :icon="item.icon" :prefix="item.prefix"
                             :suffix="item.suffix" :number="item.number" :rows="item.rows" :autosize="item.autosize" style="width: 100%;"/>

                      <Select v-if="item.element === 'select'" v-model="model[field.projectName][item.prop]" :placeholder="item.placeholder"
                              :size="item.size" :disabled="true" :filterable="item.filterable" :multiple="item.multiple" style="height:35px;width: 100%;">
                              transfer style="height:35px;">
                        <Option v-for="(opt, index) in item.option" :key="index" :value="opt.value">{{ opt.label }}</Option>
                      </Select>

                      <!-- 选择器 -->
                      <MyCascader v-if="item.element === 'cascader'" :size="item.size" :disabled="true"
                                  :placeholder="item.placeholder" v-model="model[field.projectName][item.prop]" :options="item.option"
                                  clearable   style="width: 100%"/>

                      <!-- 级联选择 -->
                      <DatePicker v-if="item.element === 'date'" :editable="false" :type="item.type" v-model="model[field.projectName][item.prop]"
                                  :options="item.options" :format="item.format" :placeholder="item.placeholder" :size="item.size"
                                  :disabled="true" :style="item.elemWidth" transfer style="height:35px;width: 100%;"/>

                      <!-- 日期选择器 -->
                      <TimePicker v-if="item.element === 'time'" :type="item.type" v-model="model[field.projectName][item.prop]"
                                  :format="item.format" :placeholder="item.placeholder" :size="item.size" :disabled="true"
                                  :style="item.elemWidth" transfer style="height:35px;width: 100%;"/>

                      <!-- 单选框 -->
                      <RadioGroup v-if="item.element === 'radio'" :type="item.type" v-model="model[field.projectName][item.prop]" :size="item.size"
                                  :vertical="item.vertical" style="width: 100%">
                        <Radio v-for="(opt, index) in item.option" :key="index" :label="opt.value" :size="item.size" :disabled="true">{{ opt.label }}</Radio>
                      </RadioGroup>

                      <!-- 多选框 -->
                      <MyCheckBox :key="item.prop+index" v-if="item.element === 'checkbox'"  :enumList="item.option" :dataStr.sync="model[field.projectName][item.prop]"
                                  :disabled="true" style="width: 100%"/>

                      <!-- 多选框 -->
                    </FormItem>
                  </Col>
                </Row>
              </template>
            </Form>
          </el-collapse-item>

        </Card>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: "RequiredManageField",
  props: {
    queryProjectsData:{
      type: Array,
      default:()=>[]
    },
  },
  computed:{

  },
  watch:{
  },
  data() {
    return {
      activeNames:[],
      model:{},
      bmiModel:{heightId:"",weightId:"",bmiId:""},
      modelProjectIdMap:{},
      fieldConfigMap:{},
      projectElements:[],
      fieldFomat: [],
      projectsData: [],
      collapseItemShow:false,
    };
  },
  mounted() {
    this.projectsData = [...this.queryProjectsData];

    this.fieldFomat = this.defineFomat();
    this.model = {}
    this.modelProjectIdMap = {}
    this.projectElements = []
    this.projectsData.forEach(item=>{
      this.model[item.projectName] = {}
      this.modelProjectIdMap[item.projectName] = item.projectId;
      this.activeNames.push(item.projectName);
    })
    this.collapseItemShow = true;
  },
  methods: {
    defineFomat(){
      const map = new Map();
      map.set(1, this.formatInput)
      map.set(2, this.formatNumberInput)
      map.set(3, this.formatDigitInput)
      map.set(4, this.formatRadio)
      map.set(5, this.formatRadio)
      map.set(6, this.formatCheckBox)
      map.set(7, this.formatCheckBox)
      map.set(8, this.formatSelect)
      map.set(9, this.formatSelect)
      map.set(10, this.formatCascader)
      map.set(11, this.formatCascader)
      map.set(12, this.formatDatePicker)
      map.set(13, this.formatYearPicker)
      map.set(14, this.formatYearMonthPicker)
      map.set(15, this.formatTextArea)
      return map
    },
    getRowElements(projectName, configs, checkStatus){
      let elements = this.projectElements[projectName];
      if(elements && elements.length > 0) {
        return elements;
      }

      elements = [];
      let filer = this.fieldFomat;
      configs.forEach((field, index)=>{
        this.fieldConfigMap[field.fieldId] = field;

        //设置表单
        let callback = filer.get(field.elementType)
        if (callback){
          let ele = callback(field)
          if (ele !== null){
            ele.optionIndex = index;
            ele.isStartIndex = index == 0 ? true : false;
            elements.push(ele);
          }
        }

        //设置表单值
        if (field.projectValue){
          this.model[projectName][field.fieldId] = field.projectValue;
        }else if(field.defaultValue && (!checkStatus || checkStatus == 1)){
          this.model[projectName][field.fieldId] = field.defaultValue;
        }else{
          this.model[projectName][field.fieldId] = "";
        }

        if(field.fieldCode === 'height'){
          this.bmiModel.heightId = field.fieldId;
        }else if(field.fieldCode === 'weight'){
          this.bmiModel.weightId = field.fieldId;
        }else if(field.fieldCode === 'bmi'){
          this.bmiModel.bmiId = field.fieldId;
        }
      })
      this.$set(this, "model", this.model);

      this.projectElements[projectName] = elements;
      return elements;

    },
    getColElements(projectName, rowIndex){
      let elements = this.projectElements[projectName];
      elements = elements.filter((item, index) => index >= rowIndex);
      let elementColumn = 0;
      elements.forEach((field, index) => {
        if(elementColumn < 24){
          field.isShow = true;
          elementColumn += (!field.columnNumber ? 6 : field.columnNumber);
          if(elementColumn >= 24 && index != (elements.length - 1)){
            elements[index + 1].isStartIndex = true;
          }
        }else{
          field.isShow = false;
        }
      });
      return elements;
    },
    countChineseChars(str) {
      let count = 0;
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) >= 0x4e00 && str.charCodeAt(i) <= 0x9fff) {
          count++;
        }
      }
      return count;
    },
    calFieldNameLength(fieldName){
      if(!fieldName) {
        return 30;
      }

      let length = this.countChineseChars(fieldName);
      if(fieldName.length !== length){
        length = length + (fieldName.trim().length - length - 1);
      }

      let width = 45;
      if(length === 2){
        width = 60;
      }else if(length === 3){
        width = 75;
      }else if(length === 4){
        width = 88;
      }else if(length === 5){
        width = 100;
      }else if(length === 6){
        width = 115;
      }else if(length === 7){
        width = 135;
      }else if(length === 8){
        width = 145;
      }else if(length === 9){
        width = 150;
      }else if(length === 10){
        width = 155;
      }else if(length === 11){
        width = 160;
      }else if(length === 12){
        width = 165;
      }else if(length === 13){
        width = 170;
      }else if(length === 14){
        width = 175;
      }else if(length === 150){
        width = 180;
      }

      if(fieldName.indexOf("(") > -1){
        width = width + 5;
      }

      return width;
    },
    setFormParam(field, element, placeholder){
      let obj = Object.assign({}, field);
      obj.label = field.fieldName;
      obj.fieldCode = field.fieldCode;
      obj.prop = field.fieldId + '';
      obj.disabled = field.isRead === 2;
      obj.labelWidth = this.calFieldNameLength(field.fieldName);
      obj.minWidth = 140;
      obj.width = {'font-weight': 'bold'};

      if(placeholder){
        obj.placeholder = placeholder;
      }
      if(element){
        obj.element = element;
      }

      return obj;
    },
    formatInput(field){
      let obj = this.setFormParam(field, null, "请输入");
      obj.width = {'font-weight': 'bold', 'height': '35px', 'line-height': '35px'};
      if (field.unit){
        obj.unit = field.unit;
      }
      return obj
    },
    formatNumberInput(field){
      let obj = this.setFormParam(field, "number", "请输入");
      obj.width = {'font-weight': 'bold', 'height': '35px', 'line-height': '35px'};
      obj.elemWidth = {'height': '35px'};

      if (field.startRange){
        obj.max= parseFloat(field.startRange)
      }
      if (field.endRange){
        obj.min= parseFloat(field.endRange)
      }
      if (field.unit){
        obj.unit = field.unit;
      }
      return obj
    },
    formatDigitInput(field){
      let obj = this.setFormParam(field, "digit", "请输入");
      obj.width = {'font-weight': 'bold', 'height': '35px', 'line-height': '35px'};

      if (field.decimalLimit){
        obj.step = field.decimalLimit === 1 ? 0.1 : (field.decimalLimit === 2 ? 0.01 : 1)
      }else {
        obj.step=0.01
      }
      if (field.startRange){
        obj.max= parseFloat(field.startRange)
      }
      if (field.endRange){
        obj.min= parseFloat(field.endRange)
      }
      if (field.unit){
        obj.unit = field.unit;
      }
      return obj
    },
    formatRadio(field){
      let obj = this.setFormParam(field, "radio");
      obj.option = this.loadOptions(field);
      obj.width = {'font-weight': 'bold', 'width': '500px'};
      return obj;
    },
    formatCheckBox(field){
      let options = [];
      if (field.options){
        field.options.forEach(item=>{
          let option  = {value: item.name, code: item.id+''}
          options.push(option)
        })
      }

      let obj = this.setFormParam(field, "checkbox");
      obj.option = options;
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    formatSelect(field){
      let obj = this.setFormParam(field, "select");
      obj.option = this.loadOptions(field);
      obj.width = {'font-weight': 'bold'};
      return obj
    },
    formatTextArea(field){
      let obj = this.setFormParam(field, "textarea");
      obj.autosize = {minRows: 4};
      // obj.width = {'font-weight': 'bold', 'width': '1000px'};
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    //渲染树状选择框
    formatCascader(field){
      let obj = this.setFormParam(field, "cascader", "请选择");
      obj.option = this.loadOptions(field);
      obj.code = "id";
      obj.name = "name";
      obj.width = {'font-weight': 'bold'};
      obj.elemWidth = {'width': '300px'};
      obj.elemWidth = {};
      obj.filterable = true;
      return obj;
    },
    formatYearPicker(field){
      let obj = this.setFormParam(field, "date", "请选择");
      obj.type = 'year';
      obj.format = 'yyyy';
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    formatYearMonthPicker(field){
      let obj = this.setFormParam(field, "date", "请选择");
      obj.type = 'year';
      obj.format = 'yyyy-MM';
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    formatDatePicker(field){
      let obj = this.setFormParam(field, "date", "请选择");
      obj.type = 'date';
      obj.format = 'yyyy-MM-dd';
      obj.width = {'font-weight': 'bold'};
      return obj;
    },
    loadOptions(field){
      let options = [];
      if (field.treeOptions && !field.options){
        options = field.treeOptions;
       /* field.treeOptions.forEach(item=>{
          if (item.isShow === 1){
            let childs = [];
            let option = {label: item.name, value: item.id}
            if (item.children && item.children.length > 0){
              item.children.forEach(child=>{
                if (child.isShow === 1){
                  childs.push({label: child.name, value: child.id})
                }
              })
              option.children = childs;
            }
            options.push(option)
          }
        })*/
      }else if (!field.treeOptions && field.options){
        field.options.forEach(item=>{
          options.push({label: item.name, value: item.id})
        })
      }
      return options
    },
  }
};
</script>
<style lang="postcss" scoped>
 /* 隐藏箭头 */
 ::v-deep .el-collapse-item__arrow {display: none !important;}
 /* 阻止标题区域点击 */
 ::v-deep .el-collapse-item__header {pointer-events: none;  /* 禁止所有交互 */border: none;padding-bottom: 0;}
 ::v-deep .el-collapse-item__wrap {border: none;}
 /* 恢复内容区域的交互（可选） */
 ::v-deep .el-collapse-item__content {pointer-events: auto;font-size: 13px;color: #303133;line-height: 1.769230769230769;}
 /deep/ .ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
 /deep/ .ivu-checkbox-disabled+span {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
 /deep/ .el-input.is-disabled .el-input__inner {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
 /deep/ .ivu-select-disabled .ivu-select-selection {background-color: #f3f3f38c;opacity: 1;cursor: not-allowed;color: #303133;}
 /deep/ .el-input__inner {height: 35px;line-height: 35px;}
 /deep/ .el-input__icon{line-height: 35px;}
 /deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
 /deep/ .ivu-form-item-content {position: relative;line-height: 35px;font-size: 14px;}
 /deep/ .ivu-input {height: 35px;line-height: 35px;}

</style>
